/* AIMER · LP Anel Classic: palco com sequência de frames no canvas, visualizador 360°, pedras, trio e sacola. Sem framework. */
(function () {
  'use strict';

  var raiz = document.getElementById('lp-classic');
  if (!raiz) return;
  var html = document.documentElement;
  var qs = function (s, el) { return (el || raiz).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || raiz).querySelectorAll(s)); };

  /* ---------- Sacola: usa a gaveta do próprio tema ---------- */
  var gaveta = function () { return document.querySelector('cart-drawer'); };

  function adicionar(itens) {
    var g = gaveta();
    var corpo = { items: itens };
    if (g && g.getSectionsToRender) {
      corpo.sections = g.getSectionsToRender().map(function (s) { return s.id; });
      corpo.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Não foi possível adicionar agora.');
        if (g && g.renderContents && res.j.sections) {
          g.classList.remove('is-empty');
          g.renderContents(res.j);
        } else {
          window.location.href = window.routes.cart_url;
        }
        return res.j;
      });
  }

  /* ---------- Pedras ---------- */
  var cards = qsa('.lp-card');
  var carrossel = qs('.lp-carrossel');
  var cardAtivo = cards[0];

  function versaoAtiva(card) { return qs('.lp-versao:not([hidden])', card); }

  cards.forEach(function (card) {
    qsa('.lp-banho', card).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var alvo = qs('.lp-versao[data-banho="' + btn.getAttribute('data-para') + '"]', card);
        if (!alvo) return;
        qsa('.lp-versao', card).forEach(function (v) { v.hidden = v !== alvo; });
        var foco = qs('.lp-banho[data-para="' + btn.getAttribute('data-para') + '"]', alvo);
        if (foco) foco.focus({ preventScroll: true });
        ativar(card);
      });
    });

    qsa('.lp-versao', card).forEach(function (form) {
      form.addEventListener('change', function () { ativar(card); });
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var escolhido = qs('input[name="id"]:checked', form);
        var msg = qs('.lp-msg', form);
        var botao = qs('button[type="submit"]', form);
        msg.classList.remove('is-erro');
        if (!escolhido) {
          msg.textContent = 'Escolha o aro para adicionar à sacola.';
          msg.classList.add('is-erro');
          var primeiro = qs('input[name="id"]:not([disabled])', form);
          if (primeiro) primeiro.focus();
          return;
        }
        botao.disabled = true;
        msg.textContent = '';
        adicionar([{ id: Number(escolhido.value), quantity: 1 }])
          .then(function () { msg.textContent = 'Na sacola.'; })
          .catch(function (e) { msg.textContent = e.message; msg.classList.add('is-erro'); })
          .then(function () { botao.disabled = false; });
      });
    });
  });

  qsa('[data-seta]').forEach(function (b) {
    b.addEventListener('click', function () {
      carrossel.scrollBy({ left: Number(b.getAttribute('data-seta')) * (cards[0].offsetWidth + 14), behavior: 'smooth' });
    });
  });

  cards.forEach(function (c) { c.addEventListener('click', function () { if (c !== cardAtivo) ativar(c); }); });

  /* No celular o cartão ativo segue o snap; no computador, vários aparecem juntos e vale o clique */
  if ('IntersectionObserver' in window && carrossel && window.innerWidth < 750) {
    var ioCard = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) ativar(e.target); });
    }, { root: carrossel, threshold: 0.7 });
    cards.forEach(function (c) { ioCard.observe(c); });
  }

  /* ---------- Trio: mesma pedra e mesmo banho, só peças com estoque ---------- */
  var trio = qs('.lp-trio');
  var dadosTrio = [];
  try { dadosTrio = JSON.parse(document.getElementById('lp-trio-dados').textContent); } catch (e) {}

  function pecaTrio(p) { return dadosTrio.filter(function (x) { return x.pedra === p.pedra && x.banho === p.banho; }); }

  function trioCompletos() {
    var nomes = [];
    cards.forEach(function (c) {
      qsa('.lp-versao', c).forEach(function (v) {
        var d = pecaTrio({ pedra: c.getAttribute('data-pedra'), banho: v.getAttribute('data-banho') });
        var tipos = d.map(function (x) { return x.tipo; });
        if (tipos.indexOf('brinco') > -1 && tipos.indexOf('colar') > -1) nomes.push({ card: c, banho: v.getAttribute('data-banho'), txt: c.getAttribute('data-nome') + ', ' + v.getAttribute('data-banho-min') });
      });
    });
    return nomes;
  }

  function desenharTrio(card) {
    if (!trio) return;
    var v = versaoAtiva(card);
    if (!v) return;
    var pedra = card.getAttribute('data-pedra');
    var banho = v.getAttribute('data-banho');
    var banhoTxt = v.getAttribute('data-banho-min');
    var outras = pecaTrio({ pedra: pedra, banho: banho });
    var foto = qs('.lp-versao__foto img', v);
    var preco = qs('.lp-preco strong', v);

    qs('.lp-trio__de').textContent = card.getAttribute('data-nome') + ', ' + banhoTxt + '.';

    var pecas = qs('.lp-trio__pecas');
    pecas.textContent = '';
    function bloco(url, img, nome, valor) {
      var a = document.createElement('a'); a.className = 'lp-trio__peca'; a.href = url;
      var i = document.createElement('img'); i.src = img; i.alt = nome; i.loading = 'lazy'; i.width = 300; i.height = 300;
      var s = document.createElement('strong'); s.textContent = nome;
      var t = document.createElement('span'); t.textContent = valor;
      a.appendChild(i); a.appendChild(s); a.appendChild(t);
      pecas.appendChild(a);
    }
    if (outras.length) bloco(qs('.lp-versao__foto', v).getAttribute('href'), foto ? foto.currentSrc || foto.src : '', 'Anel', preco ? preco.textContent : '');
    outras.forEach(function (p) { bloco(p.url, p.img, p.tipo === 'brinco' ? 'Brinco' : 'Colar', p.preco); });

    var aros = qsa('input[name="id"]:not([disabled])', v);
    var sel = qs('#lp-trio-aro');
    sel.textContent = '';
    aros.forEach(function (r) {
      var o = document.createElement('option');
      o.value = r.value;
      o.textContent = r.parentNode.querySelector('span').firstChild.textContent;
      if (r.checked) o.selected = true;
      sel.appendChild(o);
    });

    var falta = qs('.lp-trio__falta');
    falta.textContent = '';
    var add = qs('.lp-trio__add');
    var caixaAro = qs('.lp-trio__aro');
    var tipos = outras.map(function (x) { return x.tipo; });
    if (outras.length === 2) {
      add.hidden = false; caixaAro.hidden = false;
      add.textContent = 'Adicionar as 3 peças';
    } else {
      var txt = '';
      if (outras.length === 1) {
        txt = 'Esta pedra não tem ' + (tipos[0] === 'brinco' ? 'colar' : 'brinco') + ' em ' + banhoTxt + ' agora.';
        add.hidden = false; caixaAro.hidden = false;
        add.textContent = 'Adicionar as 2 peças';
      } else {
        txt = 'Esta pedra não tem brinco nem colar em ' + banhoTxt + ' agora.';
        add.hidden = true; caixaAro.hidden = true;
      }
      var completos = trioCompletos();
      falta.appendChild(document.createTextNode(txt + (completos.length ? ' Trios completos hoje:' : '')));
      if (completos.length) {
        var linha = document.createElement('span');
        linha.style.display = 'block';
        completos.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button'; b.textContent = c.txt;
          b.addEventListener('click', function () { irPara(c.card, c.banho); });
          linha.appendChild(b);
        });
        falta.appendChild(linha);
      }
    }
    qs('.lp-trio__msg').textContent = '';
    trio.hidden = false;
  }

  function irPara(card, banho) {
    var alvo = qs('.lp-versao[data-banho="' + banho + '"]', card);
    if (alvo) qsa('.lp-versao', card).forEach(function (v) { v.hidden = v !== alvo; });
    carrossel.scrollTo({ left: card.offsetLeft - carrossel.offsetLeft - 20, behavior: 'smooth' });
    ativar(card);
  }

  function ativar(card) {
    if (!card) return;
    cardAtivo = card;
    cards.forEach(function (c) { c.classList.toggle('is-ativo', c === card); });
    desenharTrio(card);
  }

  if (trio) {
    qs('.lp-trio__add').addEventListener('click', function () {
      var v = versaoAtiva(cardAtivo);
      var msg = qs('.lp-trio__msg');
      var sel = qs('#lp-trio-aro');
      var botao = this;
      msg.classList.remove('is-erro');
      if (!sel.value) { msg.textContent = 'Escolha o aro do anel.'; msg.classList.add('is-erro'); return; }
      var itens = [{ id: Number(sel.value), quantity: 1 }];
      pecaTrio({ pedra: cardAtivo.getAttribute('data-pedra'), banho: v.getAttribute('data-banho') }).forEach(function (p) { itens.push({ id: p.id, quantity: 1 }); });
      botao.disabled = true;
      adicionar(itens)
        .then(function () { msg.textContent = 'Na sacola.'; })
        .catch(function (e) { msg.textContent = e.message; msg.classList.add('is-erro'); })
        .then(function () { botao.disabled = false; });
    });
    ativar(cards[0]);
  }

  /* ---------- Barra do rodapé ---------- */
  var palco = qs('.lp-palco');
  var barra = qs('.lp-barra');
  var secPedras = qs('.lp-pedras');
  if ('IntersectionObserver' in window && palco && barra) {
    var noPalco = true, naPedra = false, passou = false;
    var ajustaBarra = function () {
      var on = passou && !noPalco && !naPedra;
      barra.hidden = !on;
      html.classList.toggle('lp-barra-on', on);
    };
    new IntersectionObserver(function (es) {
      noPalco = es[0].isIntersecting;
      passou = es[0].boundingClientRect.bottom <= 0 || passou;
      if (es[0].boundingClientRect.top > 0) passou = false;
      html.classList.toggle('lp-no-palco', noPalco && html.classList.contains('lp-anima'));
      ajustaBarra();
    }).observe(palco);
    new IntersectionObserver(function (es) {
      naPedra = es[0].isIntersecting;
      ajustaBarra();
    }, { rootMargin: '-35% 0px -35% 0px' }).observe(secPedras);
  }

  /* ---------- Modo estático: sem movimento automático, só um fade ao entrar na tela ---------- */
  function iniciarEstatico() {
    if (!('IntersectionObserver' in window)) return;
    var els = qsa('.lp-palco__explodida, .lp-legendas, .lp-frase');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('lp-fade'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { e.classList.add('lp-fade'); io.observe(e); });
  }

  if (html.classList.contains('lp-estatico')) { iniciarEstatico(); return; }

  /* GSAP só depois do load, com a thread ociosa: até a primeira rolagem nada anima e a âncora já está na tela */
  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/';
  function script(src) {
    return new Promise(function (ok, erro) {
      var el = document.createElement('script');
      el.src = src; el.async = false; el.onload = ok; el.onerror = erro;
      document.head.appendChild(el);
    });
  }
  function semAnimacao() {
    html.classList.remove('lp-anima', 'lp-no-palco');
    html.classList.add('lp-estatico');
    iniciarEstatico();
  }
  function comecar() {
    Promise.all([script(CDN + 'gsap.min.js'), script(CDN + 'ScrollTrigger.min.js')]).then(iniciarPalco).catch(semAnimacao);
  }
  function aposLoad() {
    if ('requestIdleCallback' in window) requestIdleCallback(comecar, { timeout: 1500 });
    else setTimeout(comecar, 200);
  }
  if (document.readyState === 'complete') aposLoad();
  else window.addEventListener('load', aposLoad, { once: true });

  /* ---------- Palco ---------- */
  function iniciarPalco() {
  var ULTIMO = 120;                    /* 121 frames por clipe, de 000 a 120 */
  var ENCAIXE = 84;                    /* frame da ANATOMIA em que a pedra trava */
  var fixo = qs('.lp-palco__fixo');
  var canvas = qs('.lp-palco__canvas');
  var ctx = canvas.getContext('2d');
  var ancoraImg = qs('.lp-palco__ancora');
  var base = raiz.getAttribute('data-frames');
  var leve = html.classList.contains('lp-leve');
  var passo = leve ? 2 : 1;
  /* 720 em todos os aparelhos: o CDN recodifica e o width=540 sai mais pesado (média de 16,1 KB contra 13,8 KB) */
  var largura = 720;
  var seqs = { anat: [], giro: [] };

  /* v: os frames com fundo transparente substituíram os antigos com os mesmos nomes. O CDN só renova o cache quando v muda */
  function urlFrame(seq, i) { return base + 'lp-classic-' + seq + '-' + ('00' + i).slice(-3) + '.webp?width=' + largura + '&v=6'; }

  /* Carregamento por prioridade, na ordem em que o scroll pede: 1 a cada 8 frames depois do load,
     e o resto só quando a pessoa começar a rolar (quem sai sem rolar não baixa os 3 MB) */
  var fila = [];
  var i8;
  for (i8 = ULTIMO; i8 >= 0; i8 -= 8) fila.push(['anat', i8]);
  for (i8 = 0; i8 <= ULTIMO; i8 += 8) fila.push(['giro', i8]);
  var resto = [];
  for (i8 = ULTIMO; i8 >= 0; i8 -= passo) { if (i8 % 8) resto.push(['anat', i8]); }
  for (i8 = 0; i8 <= ULTIMO; i8 += passo) { if (i8 % 8) resto.push(['giro', i8]); }
  function pedirResto() {
    if (!resto) return;
    fila = fila.concat(resto);
    resto = null;
    carregar();
  }
  var ativos = 0;
  function carregar() {
    while (ativos < 6 && fila.length) {
      (function (item) {
        ativos++;
        var img = new Image();
        img.decoding = 'async';
        img.onload = function () {
          seqs[item[0]][item[1]] = img;
          ativos--;
          pedir();
          carregar();
        };
        img.onerror = function () { ativos--; carregar(); };
        img.src = urlFrame(item[0], item[1]);
      })(fila.shift());
    }
  }

  function maisProximo(seq, i) {
    var lista = seqs[seq];
    if (lista[i]) return lista[i];
    for (var d = 1; d <= ULTIMO; d++) {
      if (lista[i - d]) return lista[i - d];
      if (lista[i + d]) return lista[i + d];
    }
    return null;
  }

  /* Mapa do scroll: 0–15% abertura · 15–45% desmonta · 45–60% monta · 60–100% gira */
  function frameDe(p) {
    if (p < 0.15) return ['anat', ULTIMO];
    if (p < 0.30) return ['anat', Math.round(ULTIMO - (p - 0.15) / 0.15 * (ULTIMO - 34))];
    if (p < 0.45) return ['anat', Math.round(34 - (p - 0.30) / 0.15 * 34)];
    if (p < 0.60) return ['anat', Math.round((p - 0.45) / 0.15 * ULTIMO)];
    return ['giro', Math.min(ULTIMO, Math.round((p - 0.60) / 0.40 * ULTIMO))];
  }

  function faixa(p, a, b, c, d) {
    if (p <= a || p >= d) return 0;
    if (p < b) return (p - a) / (b - a);
    if (p <= c) return 1;
    return (d - p) / (d - c);
  }
  var suave = function (t) { return t * t * (3 - 2 * t); };

  /* Geometria: a mesma do object-fit do canvas, para ligar as legendas às partes */
  var W = 0, H = 0, escala = 1, ox = 0, oy = 0, celular = true, deslX = 0, zoom = 1, baseZoom = 1, yAbertura = 0;
  var DIR_PECAS = 570;    /* borda direita das partes no frame 000 da ANATOMIA */
  var PARTES = [
    { y: 216, x: 452 },   /* ponto do fio sobre a pedra */
    { y: 500, x: 496 },   /* colar da cravação */
    { y: 1010, x: 548 }   /* aro */
  ];
  var caixaLegendas = qs('.lp-legendas');
  var caixaFios = qs('.lp-fios');
  var legendas = qsa('.lp-legenda');
  var fios = qsa('.lp-fios path');
  var pontos = qsa('.lp-fios circle');

  function medir() {
    W = fixo.clientWidth; H = fixo.clientHeight;
    celular = W < 750;
    escala = celular ? Math.max(W / 720, H / 1280) : H / 1280;
    ox = (W - 720 * escala) / 2; oy = (H - 1280 * escala) / 2;
    /* No celular a peça gira até perto da borda: o enquadramento fica 6% menor para sobrar margem */
    baseZoom = celular ? 0.94 : 1;
    /* Quanto a peça desce na abertura para não encostar no texto: a conta está no CSS, para valer já na primeira pintura */
    yAbertura = parseFloat(getComputedStyle(fixo, '::before').height) || 0;
    zoom = celular ? 0.8 : 1;
    /* No celular as partes vão para a esquerda, para as legendas caberem à direita */
    var dirPecas = W / 2 + (ox + DIR_PECAS * escala - W / 2) * zoom;
    deslX = celular ? W * 0.56 - dirPecas : 0;
    qs('.lp-fios').setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    var r = Math.min(window.devicePixelRatio || 1, 2);
    var cw = Math.min(largura, Math.round(720 * escala * r));
    canvas.width = cw; canvas.height = Math.round(cw * 1280 / 720);
    desenhado = '';
    topoPalco = palco.getBoundingClientRect().top + window.scrollY;
    distPalco = H * 5;
    /* As legendas ficam fora de cena (display:none) na maior parte do tempo: abre para medir */
    caixaLegendas.style.display = 'block';
    caixaLegendas.style.visibility = 'hidden';
    legendas.forEach(function (el, i) {
      var parte = PARTES[i];
      var px = W / 2 + (ox + parte.x * escala - W / 2) * zoom + deslX;
      var py = H / 2 + (oy + parte.y * escala - H / 2) * zoom;
      var borda = W / 2 + (ox + DIR_PECAS * escala - W / 2) * zoom + deslX;
      var esq = Math.max(px + 16, celular ? borda + 8 : px + 56);
      if (i < 2 && celular) esq = px + (i === 0 ? 40 : 34);
      el.style.left = esq + 'px';
      el.style.maxWidth = (W - esq - 12) + 'px';
      el.style.width = (W - esq - 12) + 'px';
      var alt = el.offsetHeight;
      var top = Math.min(Math.max(70, py - 16), H - alt - 16);
      el.style.top = top + 'px';
      var ty = top + 15;
      fios[i].setAttribute('d', 'M' + (esq - 4) + ' ' + ty + ' L' + px + ' ' + py);
      pontos[i].setAttribute('cx', px);
      pontos[i].setAttribute('cy', py);
    });
    caixaLegendas.style.visibility = '';
    cacheEstilo.delete(caixaLegendas);
  }

  var pAlvo = 0, pAtual = 0, rafId = 0, desenhado = '', ultimoFrameAnat = ULTIMO, topoPalco = 0, distPalco = 1, cacheEstilo = new Map();
  var modoMao = false, idxMao = 0, usouMao = false;

  /* Fora de cena é display:none, não só opacidade 0: o Safari do iPhone, depois da rolagem com inércia,
     pode continuar pintando um elemento com opacidade 0. */
  function cena(el, v) {
    estilo(el, 'opacity', v.toFixed(3));
    estilo(el, 'display', v > 0.001 ? '' : 'none');
  }

  function estilo(el, prop, valor) {
    var k = cacheEstilo.get(el);
    if (!k) { k = {}; cacheEstilo.set(el, k); }
    if (k[prop] === valor) return;
    k[prop] = valor;
    el.style[prop] = valor;
  }

  function desenhar(seq, i) {
    var img = maisProximo(seq, i);
    if (!img) return;
    var chave = img.src;
    if (chave === desenhado) return;
    desenhado = chave;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    if (!canvas.classList.contains('is-pronto')) {
      canvas.classList.add('is-pronto');
      ancoraImg.style.visibility = 'hidden';
    }
  }

  var elLuz = qs('.lp-sombras__luz');
  var elAbertura = qs('.lp-abertura'), elRole = qs('.lp-role'), elFrase = qs('.lp-frase'),
    elGraus = qs('.lp-graus'), elGrausN = qs('.lp-graus span'), elMao = qs('.lp-mao'), elBrilho = qs('.lp-brilho');

  function quadro() {
    rafId = 0;
    pAtual += (pAlvo - pAtual) * 0.22;
    if (Math.abs(pAlvo - pAtual) < 0.0004) pAtual = pAlvo; else pedir();
    var p = pAtual;

    var f = frameDe(p);
    if (modoMao && usouMao) f = ['giro', ((Math.round(idxMao) % ULTIMO) + ULTIMO) % ULTIMO];
    desenhar(f[0], f[1]);

    /* Encaixe: brilho e vibração curta, uma vez a cada passagem para a frente */
    if (f[0] === 'anat' && p >= 0.45 && p < 0.60) {
      if (ultimoFrameAnat < ENCAIXE && f[1] >= ENCAIXE && pAlvo >= pAtual) {
        elBrilho.classList.remove('is-on');
        void elBrilho.offsetWidth;
        elBrilho.classList.add('is-on');
        try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
      }
      ultimoFrameAnat = f[1];
    } else if (p < 0.45) {
      ultimoFrameAnat = 0;
    }

    /* Partes para a esquerda enquanto as legendas estão em cena */
    var m = suave(faixa(p, 0.18, 0.30, 0.45, 0.54));
    var y = yAbertura * (1 - suave(Math.min(1, Math.max(0, (p - 0.09) / 0.09))));
    var t = 'translate(' + (deslX * m).toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + (baseZoom + (zoom - baseZoom) * m).toFixed(4) + ')';
    estilo(canvas, 'transform', t);
    estilo(ancoraImg, 'transform', t);

    /* Jogo de sombras: a luz anda devagar com o scroll e recua enquanto as legendas estão em cena */
    if (!leve) {
      var sol = p - 0.5;
      estilo(elLuz, 'transform', 'translate3d(' + (sol * W * 0.16).toFixed(1) + 'px,' + (sol * H * -0.05).toFixed(1) + 'px,0) rotate(' + (sol * 5).toFixed(2) + 'deg)');
    }
    estilo(elLuz, 'opacity', (1 - 0.6 * m).toFixed(3));

    cena(elAbertura, faixa(p, -1, -1, 0.09, 0.15));
    cena(elRole, faixa(p, -1, -1, 0.03, 0.08));

    var comLegendas = p > 0.28 && p < 0.475;
    estilo(caixaLegendas, 'display', comLegendas ? 'block' : 'none');
    estilo(caixaFios, 'display', comLegendas ? '' : 'none');

    legendas.forEach(function (el, i) {
      var a = 0.285 + i * 0.03;
      var v = faixa(p, a, a + 0.03, 0.445, 0.47);
      estilo(el, 'opacity', v.toFixed(3));
      estilo(el, 'transform', 'translateX(' + ((1 - v) * 10).toFixed(1) + 'px)');
      estilo(fios[i], 'strokeDashoffset', (1 - v).toFixed(3));
      estilo(pontos[i], 'opacity', v.toFixed(3));
    });

    cena(elFrase, faixa(p, 0.52, 0.55, 0.60, 0.635));

    var g = (p - 0.60) / 0.40;
    if (modoMao && usouMao) g = (((idxMao % ULTIMO) + ULTIMO) % ULTIMO) / ULTIMO;
    var graus = Math.round(Math.max(0, Math.min(1, g)) * 360);
    if (elGrausN.textContent !== String(graus)) elGrausN.textContent = graus;
    cena(elGraus, faixa(p, 0.60, 0.63, 0.97, 1.0));

    var entrou = p >= 0.995;
    if (entrou !== modoMao) {
      modoMao = entrou;
      palco.classList.toggle('is-mao', entrou);
      if (!entrou) { usouMao = false; idxMao = 0; desligarGyro(); }
    }
    cena(elMao, faixa(p, 0.985, 1, 2, 3));
  }

  function pedir() { if (!rafId) rafId = requestAnimationFrame(quadro); }

  /* Na sua mão: arrastar percorre o GIRO em loop */
  var arrastando = false, xIni = 0, idxIni = 0;
  canvas.addEventListener('pointerdown', function (ev) {
    if (!modoMao) return;
    arrastando = true; xIni = ev.clientX; idxIni = idxMao;
    palco.classList.add('is-arrastando');
    try { canvas.setPointerCapture(ev.pointerId); } catch (e) {}
  });
  canvas.addEventListener('pointermove', function (ev) {
    if (!arrastando) return;
    usouMao = true;
    idxMao = idxIni - (ev.clientX - xIni) * (ULTIMO / Math.max(W * 1.1, 320));
    pedir();
  });
  ['pointerup', 'pointercancel'].forEach(function (n) {
    canvas.addEventListener(n, function () { arrastando = false; palco.classList.remove('is-arrastando'); });
  });

  /* Giroscópio: no iPhone a permissão é pedida no toque do botão */
  var botaoGyro = qs('.lp-mao__gyro');
  var gyroLigado = false, gamma0 = null, idxGyro0 = 0;
  function aoGirar(ev) {
    if (ev.gamma === null || !modoMao) return;
    if (gamma0 === null) { gamma0 = ev.gamma; idxGyro0 = idxMao; }
    usouMao = true;
    idxMao = idxGyro0 + (ev.gamma - gamma0) / 50 * ULTIMO;
    pedir();
  }
  function ligarGyro() {
    window.addEventListener('deviceorientation', aoGirar);
    gyroLigado = true; gamma0 = null;
    botaoGyro.setAttribute('aria-pressed', 'true');
  }
  function desligarGyro() {
    if (!gyroLigado) return;
    window.removeEventListener('deviceorientation', aoGirar);
    gyroLigado = false;
    botaoGyro.setAttribute('aria-pressed', 'false');
  }
  if (botaoGyro && window.DeviceOrientationEvent && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
    botaoGyro.hidden = false;
    botaoGyro.addEventListener('click', function () {
      if (gyroLigado) { desligarGyro(); return; }
      if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission()
          .then(function (r) { if (r === 'granted') ligarGyro(); else qs('.lp-mao__dica').textContent = 'Sem o sensor, arraste para girar a peça.'; })
          .catch(function () { qs('.lp-mao__dica').textContent = 'Sem o sensor, arraste para girar a peça.'; });
      } else {
        ligarGyro();
      }
    });
  }

  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.config({ ignoreMobileResize: true });
  medir();
  ScrollTrigger.create({
    trigger: palco,
    start: 'top top',
    end: function () { return '+=' + (fixo.clientHeight * 5); },
    onUpdate: function (self) { pAlvo = self.progress; pedir(); },
    onRefresh: function (self) { medir(); pAlvo = self.progress; pedir(); }
  });
  /* Posição direto do scroll: na inércia do iPhone e no elástico do topo o callback pode não chegar até o valor final */
  function sincronizar() {
    pAlvo = Math.min(1, Math.max(0, (window.scrollY - topoPalco) / distPalco));
    pedir();
  }
  window.addEventListener('scroll', sincronizar, { passive: true });
  ['scrollend', 'touchend', 'pageshow'].forEach(function (n) { window.addEventListener(n, sincronizar, { passive: true }); });
  document.addEventListener('visibilitychange', sincronizar);

  carregar();
  if (window.scrollY > 0) pedirResto();
  ['scroll', 'touchstart', 'wheel', 'keydown'].forEach(function (n) {
    window.addEventListener(n, pedirResto, { once: true, passive: true });
  });
  pedir();

  /* Exposto só para o QA: posição atual e frames já carregados */
  window.__lpClassic = function () {
    return { p: pAtual, anat: seqs.anat.filter(Boolean).length, giro: seqs.giro.filter(Boolean).length, modoMao: modoMao };
  };
  }
})();
